import tag from '@123/druid/dist/Framework/Decorators/Tag';
import MollieInputUI from '@Component/Mollie/Input/Type/MollieInputUI';
import type {MollieComponentEvent} from '@Component/Mollie/Input/Type/MollieComponent';

interface IconClasses {
    success: string;
    error: string;
}

@tag('dr-mollie-input')
export default class MollieInput extends HTMLElement {
    declare private ui: MollieInputUI;
    private readonly iconClasses: IconClasses = {
        success: 'c-mollie-form-icon--success',
        error: 'c-mollie-form-icon--error',
    };

    get type(): string {
        return this.attributeMap().getString('type', '');
    }

    public connectedCallback(): void {
        if (typeof window.mollie === 'undefined') {
            return;
        }

        this.ui = new MollieInputUI(this);
        this.ui.component.addEventListener('change', (event: MollieComponentEvent) => this.onChange(event));
        this.ui.component.addEventListener('focus', (event: MollieComponentEvent) => this.sendEvent('focus', event));
        this.ui.component.addEventListener('blur', (event: MollieComponentEvent) => this.sendEvent('blur', event));
    }

    public disconnectedCallback(): void {
        if (typeof this.ui === 'undefined') {
            return;
        }

        this.ui.component.removeEventListener('change');
        this.ui.component.removeEventListener('focus');
        this.ui.component.removeEventListener('blur');
    }

    private onChange(event: MollieComponentEvent): void {
        if (event.touched === false) {
            return;
        }

        this.ui.icon.classList.remove(this.iconClasses.success, this.iconClasses.error);
        if (event.valid) {
            this.ui.icon.classList.add(this.iconClasses.success);
        } else {
            this.ui.icon.classList.add(this.iconClasses.error);
        }

        this.sendEvent('change', event);
    }

    private sendEvent(eventType: string, mollieEvent: MollieComponentEvent): void {
        this.dispatchEvent(new CustomEvent(eventType, {bubbles: true, detail: mollieEvent}));
    }
}
